<template>
    <div class="n-pb-4">
        <div class="c-banner-jdetail n-col-1 n-border-box n-overflow-hidden">
            <!-- <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage> -->

            <div class="c-banner-text-jdetail c-max-width n-m-auto n-p-3 n-flex n-flex-a-c home-banner-text">
                <a-row :gutter="[20]"
                       class="n-col-1"
                       align="middle"
                       v-if="contentData.title">
                    <a-col :span="24"
                           :lg="18">

                        <div class="n-flex n-flex-a-c n-f-6">
                            <router-link class="n-f-normal n-m-0 c-hover n-pointer n-c-1 c-link c-tab-link c-tab-link-event"
                                         :to="{ name: 'journal' }">{{ LAN.nav.home }}</router-link>
                            <span class="n-f-normal n-m-0 c-hover n-pointer n-c-1 n-plr-1">></span>
                            <a href="javascript:;"
                               class="n-f-normal n-m-0 c-hover n-pointer n-c-1 c-link c-tab-link c-tab-link-event"
                               @click="goList">{{ data.name }} </a>
                        </div>

                        <h3 class="n-f-normal j-detail-title n-m-0 n-c-1 n-mt-4"
                            v-html="contentData.title"></h3>

                        <div class="n-c-1 n-mt-1 n-block">
                            <span class="n-block"
                                  v-if="contentData.totalPages">{{ contentData.totalPages }} {{
                                LAN.journal.pages }}</span>

                            <span v-if="contentData.publishDate|| contentData.publishDateOnline">{{ LAN.journal.publishedOnline }}：<span>{{
                                    contentData.publishDateOnline || (contentData.publishDate||'-') }}</span></span>

                            <span class="n-c-green n-f-bold n-mlr-2"
                                  v-if="contentData.isOpenAccess">{{
                                LAN.journal.openAccess
                                }}</span>

                            <a :href="contentData.openAccessLicenseUrl"
                               target="_blank"
                               class="c-tab-link c-tab-link-event n-mr-2"
                               v-if="contentData.openAccessLicenseType">
                                <img style="height: 20px;width: auto;"
                                     :src="'/open/' + contentData.openAccessLicenseType + '.png'" />
                            </a>

                            <span class="n-c-1 n-mt-1 n-block"
                                  v-if="(contentData.cmsItemSubTypeText || '') != ''">
                                {{ "(" + contentData.cmsItemSubTypeText + ")" }}</span>

                            <span class="n-c-1 n-block n-mt-1 n-pointer c-link c-hover"
                                  v-if="contentData.doi">{{
                                contentData.doi
                                }}</span>
                        </div>

                        <div class="n-flex n-flex-a-c n-flex-j-sb n-mt-6">
                            <a-button type="primary"
                                      v-if="authChecked && auth && CONTENT"
                                      @click="openPDF">{{
                                LAN.common.PDFAll }}</a-button>

                            <a-button type="primary"
                                      v-if="authChecked && !auth && CONTENT"
                                      @click="goContact">{{
                                LAN.common.subscribe }}</a-button>

                            <a class="n-c-1 c-hover-line n-block n-flex-g n-ml-2 c-link"
                               :href="data.externalSiteUrl"
                               target="_blank"
                               v-if="data.externalSiteUrl && data.onlyExternalPublish == 0">{{
                                    LAN.journal.readOn.replace('|SITE|', data.externalSiteName).replace('|NAME|', data.name)
                                }}</a>
                        </div>

                        <!-- <div class="n-flex n-flex-s">

                            <a-button type="primary"
                                      shape="round"
                                      @click="$router.go(-1)"
                                      v-if="canBack()">
                                <template #icon>
                                    <LeftOutlined />
                                </template>
{{ LAN.common.back }}
</a-button>
</div> -->
                    </a-col>

                    <a-col :span="24"
                           :lg="6">
                        <div class="n-flex n-flex-dr-c n-flex-a-c">
                            <div class="thumb n-flex-s n-mt-2">
                                <NImage class="thumb-image n-col-1 n-h-1"
                                        type="cover"
                                        offsetY="30px"
                                        zoomView
                                        v-if="data.coverPicture"
                                        :size="300"
                                        :src="data.coverPicture"></NImage>
                            </div>

                            <div class="n-mt-2 quik-link n-flex n-flex-dr-c n-flex-a-c">
                                <a href="javascript:;"
                                   class="n-f-normal n-f-6 n-m-0 n-c-1 n-text-center c-hover n-pointer c-link c-tab-link c-tab-link-event"
                                   @click="goList">{{ LAN.journal.home }}
                                    <ArrowRightOutlined class="link-arrow" />
                                </a>
                                <a href="javascript:;"
                                   class="n-f-normal n-f-6 n-m-0 n-c-1 n-text-center c-hover n-pointer c-link c-tab-link c-tab-link-event n-mt-1"
                                   @click="goFirst">{{ LAN.journal.firstArticles }}
                                    <ArrowRightOutlined class="link-arrow" />
                                </a>
                            </div>
                        </div>

                    </a-col>
                </a-row>
            </div>
        </div>

        <div class="c-max-width n-m-auto n-mt-3 n-plr-2">
            <a-row :gutter="[20, 10]">
                <a-col :span="24"
                       :lg="18">
                    <div class="n-bg-1 n-p-3"
                         v-if="loading">
                        <ul class="n-ul n-p-0 list n-bg-1 n-mt-2">
                            <li class="n-pointer n-p-4"
                                v-for="item in 3"
                                :key="item">
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-col-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                                <div class="n-skeleton n-skeleton-text n-ptb-4 n-mt-3"></div>
                            </li>
                        </ul>
                    </div>

                    <div class="n-bg-1 n-p-3"
                         v-else>

                        <article>
                            <div v-if="contentData.authors?.length > 0"
                                 class="n-flex n-flex-a-c n-flex-w"
                                 id="pop">
                                <span class="n-flex n-flex-a-c"
                                      target="_blank"
                                      v-for="(item, index) in contentData.authors"
                                      :key="index">

                                    <a-tooltip placement="topLeft"
                                               color="#fff"
                                               trigger="click"
                                               :overlayStyle="{minWidth: '320px'}"
                                               :getPopupContainer="popContainer">
                                        <template #title>
                                            <div class="n-p-1 author-tip">
                                                <h4 class="n-f-6 n-m-0 n-flex n-flex-a-c">
                                                    <span class="n-f-6 c-tab-link c-tab-link-event">
                                                        {{ item.fullName }}
                                                    </span>
                                                    <a :href="item.orcidUrl"
                                                       target="_blank"
                                                       v-if="item.orcid"
                                                       class="n-ml-1 n-pointer c-hover-up n-inline-block c-tab-link c-tab-link-event"
                                                       style="margin-top: -3px">
                                                        <img style="height: 20px; width: auto"
                                                             :src="require('@/assets/image/orcid.logo.icon.svg')">
                                                    </a>
                                                </h4>
                                                <span class="n-c-3 n-block n-mt-3"
                                                      v-if="item.title">{{ item.title
                                                    }}</span>

                                                <a :href="'mailto://' + item.email"
                                                   v-if="item.email && item.type == 'Corresponding Author'"
                                                   class="n-c-base n-pointer c-hover-line n-inline-block c-tab-link c-tab-link-event n-block n-mt-4 n-col-1">
                                                    {{ LAN.common.contact }} {{ item.fullName }}
                                                </a>

                                                <a-button type="primary"
                                                          class="n-mt-4"
                                                          @click="goAuthorPub(item.fullName)">{{
                                                        LAN.journal.vuewAuthorPub
                                                    }}</a-button>

                                                <!-- <a href="" class="c-tab-link c-tab-link-event">{{
                                                    LAN.journal.vuewAuthorPub }}</a> -->
                                            </div>
                                        </template>

                                        <a href="javascript:;"
                                           class="n-f-underline n-c-4 n-line-height-1 n-f-6 n-inline-block n-pointer c-tab-link c-tab-link-event">
                                            {{ item.fullName }}
                                        </a>
                                    </a-tooltip>

                                    <a :href="item.orcidUrl"
                                       target="_blank"
                                       v-if="item.orcid"
                                       class="n-ml-1 n-pointer c-hover-up n-inline-block c-tab-link c-tab-link-event"
                                       style="margin-top: -3px">
                                        <img style="height: 20px; width: auto"
                                             :src="require('@/assets/image/orcid.logo.icon.svg')">
                                    </a>

                                    <a :href="'mailto://' + item.email"
                                       v-if="item.email && item.type == 'Corresponding Author'"
                                       class="n-ml-1 n-pointer c-hover-up n-inline-block c-tab-link c-tab-link-event"
                                       style="margin-top: -3px">
                                        <img style="height: 20px; width: auto"
                                             :src="require('@/assets/image/mail.png')">
                                    </a>

                                    <span v-if="contentData.authors.length >= 2 && index == contentData.authors.length - 2"
                                          class="n-plr-1 n-line-height-1">&</span>
                                    <span v-else-if="index <= contentData.authors.length - 2"
                                          class="n-pr-1 n-line-height-1">,</span>
                                </span>
                            </div>

                            <div class="n-flex-s n-mt-2 n-bg-2 n-p-2"
                                 v-if="contentData?.specialIssueTitle || contentData?.specialIssueEditors">
                                <div v-html="contentData.specialIssueTitle"></div>
                                <div v-html="contentData.specialIssueEditors"></div>
                            </div>

                            <div v-if="contentData.fAbstract">
                                <h4 class="n-f-bold n-m-0 n-mt-6">{{ LAN.journal.abstract }}</h4>
                                <div v-html="contentData.fAbstract || '-'"></div>
                            </div>

                            <h4 class="n-f-bold n-m-0 n-mt-6"
                                v-if="contentData.keyword">{{ LAN.journal.keyword }}</h4>
                            <div v-if="contentData.keyword"
                                 v-html="contentData.keyword"></div>

                            <h4 class="n-f-bold n-m-0 n-mt-6"
                                v-if="contentData.mscValue">
                                {{contentData.mscType == 'MSC2000' ?LAN.journal.msc2000 :( contentData.mscType == 'MSC2010' ?
                                    LAN.journal.msc2010 : LAN.journal.msc2020) }}</h4>
                            <div class="n-mt-2"
                                 v-if="contentData.mscValue">{{ contentData.mscValue }}</div>

                            <div class="n-mt-6"
                                 v-if="(contentData.contentNotes || []).length > 0">
                                <div v-for="item in contentData.contentNotes"
                                     v-bind:key="item">
                                    <b>{{ item.noteType }}</b>
                                    <p v-for="item2 in item.value"
                                       v-html="(item2.fContent || '').replaceAll('\r\n', '<br/>').replaceAll('\n', '<br/>')"
                                       v-bind:key="item2">
                                    </p>
                                </div>
                            </div>

                            <div v-if="contentData.authors?.length > 0">
                                <h4 class="n-f-bold n-m-0 n-mt-6 n-f-6">{{ LAN.journal.authorInfo }} </h4>
                                <div>
                                    <h4 class="n-f-bold n-m-0 n-mt-1">{{ LAN.journal[contentData.authors.length == 1 ? 'authorInfoB' : 'authorInfoA']}} </h4>
                                    <span class="n-block author-row"
                                          target="_blank"
                                          v-for="(item, index) in contentData.authors"
                                          :key="index">
                                        {{ item.fullName }}{{ item.title ? `（${item.title}）` : '' }}
                                    </span>
                                </div>
                            </div>

                            <div v-if="!!contentData.contributions">
                                <h4 class="n-f-bold n-m-0 n-mt-2">{{ LAN.journal.contributions }} </h4>
                                <div v-html="contentData.contributions">
                                </div>
                            </div>

                            <div v-if="contentData.authors && contentData.authors.filter(item => item.type == 'Corresponding Author').length > 0">
                                <h4 class="n-f-bold n-m-0 n-mt-2">{{ LAN.journal[contentData.authors.filter(item => item.type == 'Corresponding Author').length == 1 ? 'contributionsAuthorA' : 'contributionsAuthorB'] }} </h4>
                                <div>
                                    {{ LAN.journal.contributionsTo }}

                                    <span v-for="(item, index) in contentData.authors.filter(item => item.type == 'Corresponding Author')"
                                          :key="index">
                                        <a class="n-c-base c-tab-link c-tab-link-event"
                                           :href="'mailto://' + item.email"
                                           v-if="item.email">{{ item.fullName
                                            }}</a><span v-else>{{ item.fullName }}</span>

                                        <span v-if="contentData.authors.filter(item => item.type == 'Corresponding Author').length >= 2 && index == contentData.authors.filter(item => item.type == 'Corresponding Author').length - 2"
                                              class="n-plr-1 n-line-height-1">or</span>
                                        <span v-else-if="index <= contentData.authors.filter(item => item.type == 'Corresponding Author').length - 2"
                                              class="n-line-height-1">, </span>
                                    </span>
                                </div>
                            </div>

                            <div v-if="(contentData.supplement || []).length > 0">
                                <h4 class="n-f-bold n-m-0 n-mt-6">{{
                                    'Supplement' + ((contentData.supplement||[]).length>1?"s":"")
                                    }}</h4>
                                <p v-for="item in contentData.supplement"
                                   v-bind:key="item">
                                    <a :href="systemUrl + item.filePath"
                                       target="_blank">{{ systemUrl + item.filePath }}</a>
                                </p>
                            </div>

                            <p class="n-mt-6">
                                <span v-if="contentData.receiveDate"> {{ LAN.journal.received }} <span class="n-f-bold n-ml-2">{{
                                            contentData.receiveDate || '-' }}</span><br></span>
                                <span v-if="contentData.receivedRevisedDate">{{ LAN.journal.receivedRevised }} <span class="n-f-bold n-ml-2">{{
                                            contentData.receivedRevisedDate ||
                                        '-' }}</span><br></span>
                                <span v-if="contentData.acceptedDate"> {{ LAN.journal.accepted }} <span class="n-f-bold n-ml-2">{{
                                            contentData.acceptedDate || '-' }}</span><br></span>
                                <span v-if="contentData.publishDateOnline || contentData.publishDate"> {{ LAN.journal.publishedOnline }} <span class="n-f-bold n-ml-2">{{
                                           contentData.publishDateOnline || ( contentData.publishDate || '-' ) }}</span></span>
                            </p>
                        </article>

                        <span class="n-f-2 n-c-2 n-mt-2 n-block"
                              v-if="contentData.updateTimeGmt">{{
                            LAN.common.updateTime }}:
                            {{ contentData.updateTimeGmt }} ({{ formatDateToLocalTime(contentData.updateTimeGmt) }})
                        </span>
                    </div>
                </a-col>
                <a-col :span="24"
                       :lg="6">
                    <div class="n-bg-1 n-p-3">
                        <router-link class="n-m-0 n-f-6 n-f-bold c-hover n-pointer c-link c-tab-link c-tab-link-event n-c-4"
                                     :to="{ name: 'journalFirst', query: { jid: ids.jid } }">
                            {{ LAN.journal.firstArticles }}
                            <ArrowRightOutlined class="link-arrow" />
                        </router-link>

                        <ul class="n-mt-6 n-ul n-p-0">
                            <li v-for="item in contents"
                                :key="item.id"
                                class="c-link n-mb-4 n-f-6 n-line-height-1-5 n-pointer c-hover">
                                <a href="javascript:;"
                                   class="c-tab-link c-tab-link-event"
                                   :class="item.id == this.ids.cid ? 'n-c-UI-blue' : 'n-c-4'"
                                   @click="item.id == this.ids.cid ? () => { } : goContent(item)">
                                    <span v-html="item.title"
                                          class="c-link"></span>
                                    <ArrowRightOutlined class="link-arrow" />
                                </a>
                            </li>
                        </ul>
                    </div>
                </a-col>
            </a-row>
        </div>

        <a-modal v-model:visible="showViewCONTENT"
                 centered
                 width="calc(100vw - 10px)"
                 height="calc(100vh - 10px)"
                 class="pdf-dialog"
                 v-if="CONTENT && auth && showViewCONTENT"
                 :bodyStyle="{ padding: 0 }"
                 :title="CONTENT.originalName"
                 :footer="null"
                 @ok="showViewCONTENT = false">
            <DocView :url="CONTENT.resourceUrl"
                     :name="CONTENT.originalName"
                     class="pdf"></DocView>
        </a-modal>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import { Modal } from 'ant-design-vue'
    import NImage from '@/components/nui/NImage/NImage.vue'
    import DocView from '@/components/nui/DocView/DocView.vue'
    import Breadcrumb from '@/components/Breadcrumb.vue'
    import { LinkOutlined, ArrowRightOutlined } from '@ant-design/icons-vue';
    import crypto from '@/assets/script/crypto';
    import nui from '@/assets/script';
    import LAN from '@/assets/script/LAN';

    export default {
        name: 'BDetail',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                ids: {},
                auth: false,
                authChecked: false,

                showViewTOC: false,
                showViewCONTENT: false,
                showViewpPreview: false,


                loading: false,
                data: {},
                contentData: {},
                contents: [],

                CONTENT: null,
                systemUrl: ""
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.systemUrl = location.origin;
                this.loading = true;

                let viewtype = this.$route.params.viewtype || '';

                this.request(this.API.getJDetailIds, {
                    params: { id: this.$route.params.cid, viewType: viewtype == 'none' ? '' : viewtype }
                }).then(res => {
                    if (res.code == 200) {
                        this.ids = res.data
                        this.loadData()
                    } else {
                        this.$router.replace({ name: '404page' });
                    }
                }).catch(err => {
                    this.$router.replace({ name: '404page' });
                })
            },
            checkContentPermission () {
                this.auth = false;
                this.authChecked = false;
                if (!this.CONTENT) {
                    return
                }
                let viewtype = this.$route.params.viewtype || '';

                this.request(this.API.checkContentPermission, {
                    params: {
                        dataid: this.ids.cid,
                        datatype: "volume",
                        viewType: viewtype == 'none' ? '' : viewtype
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.auth = res.data.hasAuth;
                        this.authChecked = true;
                    }
                })
            },
            checkAuth (callback) {
                if (!this.CONTENT) {
                    return
                }

                let viewtype = this.$route.params.viewtype || '';

                this.request(this.API.pdfCheckAuth, {
                    params: {
                        dataid: this.ids.cid,
                        datatype: "volume",
                        name: this.CONTENT.name,
                        viewType: viewtype == 'none' ? '' : viewtype
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.auth = res.data.hasAuth;
                        let url = crypto.decrypt(res.data.url);
                        callback && callback(url);
                    }
                })
            },
            openPDF () {
                this.checkAuth((url) => {
                    if ((url || '') == '') {
                        return;
                    }
                    this.CONTENT.resourceUrl = url;
                    this.showViewCONTENT = true;
                });
            },
            popContainer () {
                return document.getElementById('pop')
            },
            goAuthorPub (name) {
                this.$router.push({ name: 'journalAuthorPanel', query: { name: encodeURIComponent(name) } })
            },
            loadData () {
                this.loading = true

                let viewtype = this.$route.params.viewtype || '';

                var a = this.request(this.API.journalList, {
                    requestId: 'JDJL',
                    params: {
                        id: this.ids.jid,
                        viewType: viewtype == 'none' ? '' : viewtype
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE && res.data && res.data.id) {
                        this.data = res.data
                    } else {
                        this.$router.replace({ name: '404page' });
                    }
                })

                var b = this.request(this.API.journalDetail, {
                    requestId: 'JDJD',
                    params: {
                        contentId: this.ids.cid,
                        viewType: viewtype == 'none' ? '' : viewtype
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE && res.data && res.data.id) {
                        if (res.data.recordStatus != 'ONLINE_FIRST') {
                            this.$router.replace({ name: 'JDetail', params: { cid: res.data.id } });
                            return;
                        }
                        res.data.keyword = this.parseCoa(res.data.keyword)
                        res.data.mscValue = this.parseCoa(res.data.mscValue)

                        this.contentData = res.data

                        this.CONTENT = (this.contentData.contentPdf || []).filter(item => item.relationType == 'periodical_issue_content_pdf')[0]

                        this.checkContentPermission();
                        //YAU-486 日期格式化
                        this.contentData.openAccessLicenseType = (this.contentData.openAccessLicenseType || '').replace('CC ', '').toLowerCase()
                        this.contentData.receiveDate = nui.parseDateFormat(this.contentData.receiveDate);
                        this.contentData.receivedRevisedDate = nui.parseDateFormat(this.contentData.receivedRevisedDate);
                        this.contentData.acceptedDate = nui.parseDateFormat(this.contentData.acceptedDate);
                        this.contentData.publishDate = nui.parseDateFormat(this.contentData.publishDate);
                        this.contentData.publishDateOnline = nui.parseDateFormat(this.contentData.publishDateOnline);
                    } else {
                        this.$router.replace({ name: '404page' });
                    }
                })

                var c = this.request(this.API.journalFirst, {
                    requestId: 'journalFirst',
                    params: { periodicalId: this.ids.jid }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE && res.data && res.data.periodicalId) {
                        this.contents = res.data.content
                    } else {
                        this.$router.replace({ name: '404page' });
                    }
                })

                Promise.all([a, b, c]).then(() => {
                    this.loading = false

                    this.$nextTick(() => {
                        this.parseMathJax()
                    })
                }).catch((err) => {
                    this.loading = false

                    if (err.code != 'ERR_CANCELED') {
                        this.$router.replace({ name: '404page' });
                    }
                })
            },
            goList () {
                if (this.data.isAnnualIssue == 1) {
                    this.$router.push({ name: 'bookSuccessionList', query: { id: this.data.serialId } })
                } else {
                    this.$router.push({ name: 'journalList', query: { id: this.ids.jid } })
                }
            },
            goHome () {
                this.$router.push({ name: 'journal' })
            },
            goFirst () {
                this.$router.push({ name: 'journalFirst', query: { jid: this.ids.jid } })
            },
            goContent (data) {
                let viewtype = this.$route.params.viewtype || '';

                this.$router.push({ name: 'JFirstDetail', params: { cid: data.id } })
            },
            goContact () {
                this.$router.push({ name: 'contact' })
            }
        }),
        components: {
            NImage,
            DocView,
            Breadcrumb,
            LinkOutlined,
            ArrowRightOutlined
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .thumb {
        width: 178px;
        height: 240px;

        .thumb-image {
            transition: all 0.3s;
        }
    }

    .title-icon {
        background-color: rgb(255, 226, 186);
        color: rgb(255, 162, 66);
        padding: 5px;
    }

    .list-item {
        transition: all 0.3s;

        &:hover {
            box-shadow: $shadow-2;
        }
    }

    .book-introduce {
        table {
            display: table;
        }

        ul {
            display: none;
        }
    }

    @media screen and (max-width: 1100px) {
        .book-introduce {
            table {
                display: none;
            }

            ul {
                display: block;
            }
        }

        .book-top {
            display: block;

            .book-info {
                margin-top: 15px;
                width: auto;
            }
        }
    }
</style>
<style lang="scss">
    .pdf-dialog {
        max-width: 100% !important;

        .ant-modal-header {
            background: rgba(56, 56, 61, 1);
            padding: 10px;
            height: 40px;
            border-bottom: 0;
        }

        .ant-modal-title {
            color: $font-color-1;
        }

        .ant-modal-close-x {
            color: $font-color-1;
            width: 40px;
            height: 40px;
            line-height: 40px;
        }

        .ant-modal-content {
            height: 100%;
        }

        .ant-modal-body {
            height: calc(100% - 40px);
        }
    }

    .author-row {
        text-indent: -2em;
        margin-left: 2em;
    }

    .j-detail-title {
        font-size: 40px;
        line-height: 48px;
    }

    @media screen and (max-width: 990px) {
        .quik-link {
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-top: 10px;
            flex-wrap: wrap;

            h3 {
                padding: 0 5px;
            }
        }
    }

    .c-banner-jdetail {
        background-color: rgb(59, 3, 14);

        &:after {
            display: none;
        }
    }

    .link-arrow {
        position: relative;
        top: 1px;
        font-size: 12px;
    }
</style>